<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
      <div class="nav-item" :class="{active:type===0}" @click="toInfo('/home/zwAdmin/zwList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconliebiao"></i>
          </div>
        </div>
        职位列表
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="toInfo('/home/zwAdmin/zwForm')"
           v-if="user.admin_type===2 || user.admin_type===3|| user.admin_type===4">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconbiaodan2"></i>
          </div>
        </div>
        我的表单
      </div>
      <div class="nav-item" :class="{active:type===2}" @click="toInfo('/home/zwAdmin/jgZhiWeiFaBuShen')" style="position: relative;">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconbiaodan2"></i>
          </div>
        </div>
        职位审核
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="zwNum!==0"></i>
      </div>
    </div>

    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: "zwrAdmin",
    data() {
      return {
        type: '',
        zwNum:0
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$store.state.topNav = 3
      this.getZnx()
    },
    methods: {
      toInfo(path) {
        this.$router.push(path)
      },
      setType(type) {
        this.type = type
      },
      getZnx() {
        this.$api.apiContent.getZnx({
          adminId: this.user.id
        }).then(res => {
          this.zwNum = res.data.jobs
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
</script>

<style scoped lang="scss">

</style>